import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  EventEmitter,
  Output,
} from "@angular/core";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { NgxFileDropEntry } from "ngx-file-drop";
import { EMPTY, from, merge, Observable, Subject, Subscription } from "rxjs";
import { ChatService } from "../../chat.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@aihub/core/authorization";
import {
  catchError,
  debounceTime,
  finalize,
  map,
  switchMap,
  take,
  takeUntil,
} from "rxjs/operators";
import * as PROMPTS from "./prompt.constant";
import { Chat, Message, MessageData } from "../../types";
import { CookieService } from "ngx-cookie-service";
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import { PdfReaderService } from "../../pdf-reader.service";
import * as SAMPLE_DATA from "./sample.constant";
import { AskGenAiService } from "src/app/askGenAi.service";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

@Component({
  selector: "app-iqgen",
  templateUrl: "./iqgen.component.html",
  styleUrls: ["./iqgen.component.scss"],
})
export class IqgenComponent implements OnInit {
  @Input() subscription_id: string = "";
  @Output() displayResponse = new EventEmitter<any>();

  public formJson;
  form: FormGroup;
  public uploadIcon = false;
  showForm = false;
  pdfContents: string;
  interviewTypeExplanation = {
    Traditional: `A traditional interview is a face-to-face meeting where a job candidate meets with interviewers to discuss their qualifications and suitability for a specific job. It follows a structured format, with predetermined questions asked by the interviewer. The candidate's answers are evaluated based on their experience, skills, knowledge, and fit with the company culture. It is a widely used method for assessing candidates and making hiring decisions.`,
    Behavioral: `A behavioral interview focuses on assessing a candidate's past behavior and experiences to predict future performance. Candidates are asked specific questions about situations they have encountered, and their responses are evaluated based on skills and competencies required for the job. It provides employers with objective insights into a candidate's capabilities and fit within the organization.`,
    Technical: `A technical interview is a job interview specifically focused on assessing a candidate's technical skills and knowledge in relation to the job requirements. It usually involves questions and problem-solving scenarios related to the specific technical aspects of the position. The interviewer evaluates the candidate's ability to apply their technical knowledge, solve technical problems, and think critically. Technical interviews are commonly used in fields such as engineering, software development, IT, and other technical roles to ensure candidates have the necessary expertise for the job.`,
  };
  interviewLevelExplanation = {
    "Beginner": "Assessing basics, foundational understanding, and clear communication.",
    "Proficient": "Testing practical application, examples, and problem-solving skills.",
    "Competent": "Evaluating independent work, complex analysis, and critical thinking.",
    "Expert": "Exploring advanced concepts, industry insights, and complex strategies.",
    "Master": "Identifying peak expertise, innovation, and visionary thinking."
  };
  questionsPerDuration = {
    "30 minutes": 10,
    "1 hour": 20,
    "2 hours": 30
  }
  requiredFields = [
    "interviewRole",
    // "interviewJobDescription",
    // "interviewType",
  ];
  showUpload = true;
  fileContent = "";
  fileName = "";
  fileType = "";

  exampleCv = "./example_CV.pdf"

  disableProcessing: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private chatService: ChatService,
    private pdfReader: PdfReaderService,
    private askGenAi: AskGenAiService
  ) {}

  ngOnInit() {
    this.getFormJson();
  }

  getFormJson() {
    this.chatService.getFormJson().subscribe((res) => {
      this.formJson = res.data;
      this.initForm();
    });
  }

  initForm() {
    this.form = this.formBuilder.group(
      this.formJson.reduce(
        (acc, control) => ({ ...acc, [control.name]: "" }),
        {}
      )
    );
    this.showForm = true;
  }

  onSubmit() {
    let prompt = this.createContentPrompt();
    // this.displayResponse.emit(prompt);
    // console.log(prompt)
    // this.askGenAi.askGenAi(this.subscription_id, prompt).subscribe((response: any) => {
    //   this.askGenAi.response.next(response)
    // }
    // )

    // Last minute change for BCP -- Revert back if needed
      const modelParams = {
          max_output_tokens: 400,
          temperature: 0.2,
          truncate_at_eos: true,
          do_sample: true,
          top_p: 0.95,
          top_k: 40,
      };
      const input = {
          promptString: prompt,
          model: 'chat-bison',
          modelParams,
      };
      this.displayResponse.emit(input);
  }

  submitEnabled() {
    return this.formJson
      .filter((item) => this.requiredFields.includes(item["name"]))
      .every((item) => this.form.value[item["name"]] != "");
  }

  private createContentPrompt() {
    this.form.value["cvUpload"] = this.fileContent;
    let inputParameters = "";
    let prompt = PROMPTS.interviewBase
    let cvAddidtion = this.fileContent ? PROMPTS.cvAddidtion: "";
    prompt += cvAddidtion
    prompt += this.form.value["additionalInformation"]
    let example = PROMPTS.responseExample
    let duration = this.form.value["duration"] ? this.form.value["duration"] : "1 hour"
    let maxQuestions = this.questionsPerDuration[duration]
    for (let index = 0; index < this.formJson.length; index++) {
      let inputField = this.formJson[index];
      let inputValue = this.form.value[inputField["name"]];
      if (inputValue.trim() != "" && inputField!="additionalInformation") {
        if (inputField["name"] == "interviewType") {
          inputParameters +=
            inputField["label"] +
            ':\n"' +
            this.interviewTypeExplanation[inputValue] +
            '"\n';
        } else if (inputField["name"] == "questionLevel") {
          inputParameters +=
            inputField["label"] +
            ':\n"' +
            this.interviewLevelExplanation[inputValue] +
            '"\n';
        } else {
          inputParameters += inputField["label"] + ':\n"' + inputValue + '"\n';
        }
      }
    }
    prompt += `\nAks a maximum of ${maxQuestions} interview questions\n\n`
    prompt += inputParameters;
    prompt += example
    return prompt
  }

  // // File on drop
  // public drop(files: NgxFileDropEntry[]): void {
  //   // this.clearFile();
  //   this.uploadIcon = true;

  //   files.forEach((file) => {
  //     if (file.fileEntry.isFile) {
  //       const dropped = file.fileEntry as FileSystemFileEntry;
  //       dropped.file(async (droppedFile: File) => {
  //         if (droppedFile) {
  //           this.fileName = droppedFile.name;
  //           this.fileType = droppedFile.type;
  //           if (this.fileType.includes("pdf")) {
  //             this.readFromPdf(droppedFile);
  //           }
  //         }
  //       });
  //     }
  //   });
  // }

  readFromPdf(file: File) {
    this.pdfReader.readPdf(file).then(
      (text) => {
        this.fileContent = text;
      },
      (reason) => console.error(reason)
    );
  }

  // clearFile() {
  //   this.fileContent = "";
  //   this.fileName = null;
  // }

  /**
   * convert an image to base64
   *
   */
  public convertImageToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      if (file.size / (1024 * 512) >= 1) {
        reject(`Filesize is too big, maximum allowed file size is 512kb.`);
      }

      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(file);
    });
  }

  handleFileInput(event) {
    this.pdfReader.readPdf(event.target.files[0]).then(
      (text) => alert("PDF parsed: " + text),
      (reason) => console.error(reason)
    );
  }

  // uploadExampleCV(pdfFilePath: string): NgxFileDropEntry {
  //   let fileEntry: NgxFileDropEntry = {
  //     relativePath: pdfFilePath,
  //     fileEntry: {
  //       name: pdfFilePath.substring(pdfFilePath.lastIndexOf('/') + 1),
  //       isDirectory: false,
  //       isFile: true,
  //     },
  //   };

  //   console.warn(typeof fileEntry);
  //   return fileEntry;
  // }

  prefillSampleData() {
    // this.showUpload = false;
    this.form.patchValue(SAMPLE_DATA.form_value);
    if (SAMPLE_DATA.form_value.cvUpload) {
      // // Upload this.exampleCv
      // this.drop([
      //   this.uploadExampleCV(this.exampleCv) // some function is missing in fileEntry
      // ])
    }
  }
}
